<template>
    <div :class="theme.wrapper" ref="wrapper">
        <div :class="theme.container" ref="container">
            <slot></slot>
        </div>
    </div>
</template>

<script>
    import theme from './animationHeight.scss';

    export default {
        name: 'animation-height',
        props: {
            theme: {
                type: Object,
                default() {
                    return theme;
                }
            },
            height: {
                type: [String, Number],
                default: 'auto',
            }
        },
        mounted() {
            this.setWrapperHeight();
            window.addEventListener('resize', this.setWrapperHeight);
        },
        updated() {
            this.setWrapperHeight();
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.setWrapperHeight);
        },
        methods: {
            setWrapperHeight() {
                this.$refs.wrapper.style.height = this.height === 'auto'
                    ? this.$refs.container.getBoundingClientRect().height + 'px'
                    : this.height + 'px';
            }
        }
    }
</script>


// WEBPACK FOOTER //
// AnimationHeight.vue?89a4ca1e